import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { Input } from '@/components/uiKit/FormControl';

interface FormInputProps {
  name: string;
  control: Control<any, any>;
  label: string;
  rules?: object;
  type?: 'text' | 'password' | 'email' | 'number' | 'search' | 'tel' | 'url' | 'date' | 'time' | 'datetime-local';
}

export const FormInput = ({ name, control, label, rules, type = 'text' }: FormInputProps) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    defaultValue=""
    render={({ field, fieldState: { error } }) => (
      <Input
        variant="standard"
        label={label}
        error={!!error}
        helperText={error?.message}
        type={type}
        {...field}
        value={field.value ?? ''}
      />
    )}
  />
);
